<template>
  <div>
    TODO Proof of Monitoring Form
  </div>
</template>

<script>
export default {
  name: "POMForm"
};
</script>
